module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 6
// module chunks = 0